import { NO_KNOWN_ALLERGY_MAP } from '@models/allergy';

import { CategoryCode, ClinicalStatusCode } from 'generated/types';

export const CLINICAL_STATUS_OPTIONS = [
  { k: ClinicalStatusCode.active, v: 'Active' },
  { k: ClinicalStatusCode.inactive, v: 'Inactive' },
  { k: ClinicalStatusCode.resolved, v: 'Resolved' },
];

export const ALLERGY_TYPE_OPTIONS = [
  { k: CategoryCode.biologic, v: 'Biologic' },
  { k: CategoryCode.environment, v: 'Environment' },
  { k: CategoryCode.food, v: 'Food' },
  { k: CategoryCode.medication, v: 'Medication' },
];

export const ALLERGY_REACTION_OPTIONS = [
  { k: 'mild', v: 'Mild' },
  { k: 'moderate', v: 'Moderate' },
  { k: 'severe', v: 'Severe (Anaphylactic)' },
];

export const NEGATED_ALLERGY_OPTIONS = Object.entries(NO_KNOWN_ALLERGY_MAP).map(
  ([key, value]) => ({
    k: key,
    v: value,
  })
);
